<div class="container speedcheck-footer">
  <div class="row">

    <div class="col-12 col-sm-6">
      <div class="footer-element text-center">
        @if (!ipv4 && !ipv6) {
          <div>
            <div class="spinner"></div>
          </div>
        }
        @if (ipv4) {
          <div>
            <span class="descriptor">IPv4: </span><span class="footer-text">{{ipv4}}</span>
          </div>
        }
        @if (ipv6) {
          <div>
            <span class="descriptor">IPv6: </span><span class="footer-text">{{ipv6}}</span>
          </div>
        }
      </div>
    </div>

    <div class="col-12 col-sm-6">
      <div class="footer-element text-center" style="text-align: left;">
        <span class="descriptor">{{ 'provider.title' | translate }}</span><br>
        @if (!isp) {
          <div>
            <div class="spinner"></div>
          </div>
        }
        @if (isp) {
          <div>
            <span class="footer-text">{{isp}}</span>
          </div>
        }
      </div>
    </div>

  </div>

</div>